module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-2000.cd6d8f96.svg";